export type PaperSize = 'letter' | 'legal' | 'tabloid' | 'a4' | 'a3';

export const PAPER_DIMENSIONS: Record<PaperSize, { width: number; height: number; unit: string }> = {
    letter: { width: 8.5, height: 11, unit: 'in' },
    legal: { width: 8.5, height: 14, unit: 'in' },
    tabloid: { width: 11, height: 17, unit: 'in' },
    a4: { width: 210, height: 297, unit: 'mm' },
    a3: { width: 297, height: 420, unit: 'mm' }
};

// SRAC Brand Color (Red)
export const BRAND_COLOR = [220, 38, 38] as [number, number, number]; // #DC2626
export const BRAND_HEX = '#DC2626';

export const FONT_HELCH = 'helvetica';
